import ChairIconPath from "@ingka/ssr-icon/paths/chair";

export default ChairIconPath;
